module.exports = __webpack_public_path__ + "img/section-2-pins.51de2e82.png";